import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 .25a1 1 0 0 1 .914.594l1.767 3.975 3.93.437a1 1 0 0 1 .648 1.645l-2.683 3.13.905 4.523a1 1 0 0 1-1.467 1.07L8 13.394l-4.014 2.23a1 1 0 0 1-1.467-1.07l.905-4.523-2.683-3.13a1 1 0 0 1 .649-1.645l3.93-.437L7.085.844A1 1 0 0 1 8 .25Zm0 3.462L6.914 6.156a1 1 0 0 1-.804.588l-2.62.291L5.26 9.1a1 1 0 0 1 .22.847l-.575 2.88 2.61-1.45a1 1 0 0 1 .97 0l2.61 1.45-.576-2.88a1 1 0 0 1 .222-.847l1.769-2.064-2.62-.291a1 1 0 0 1-.804-.588L8 3.712Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconToggleStarOff16 = createIcon(IconComponent);